<template>
    <div id="programs">
        <section class="hero is-fullheight fitco standing">
            <div class="hero-head">
                <navigation></navigation>
            </div>
            <div class="hero-body">
                <div class="container">
                    <player :options="videoOptions"></player>
                </div>
            </div>
        </section>
        <section class="hero is-white">
            <div class="hero-body">
                <div class="container">
                    <h1 class="subtitle is-5 has-text-dark">
                        We offer a full -service program with the goal of saving your company time and money while
                        enhancing your company connectivity and culture. The CEO of FitCo, Stacy Wig, is not just
                        experienced and educated in behavior modification strategies, physical therapy, fitness, holistic
                        health, and nutrition, but is a business woman who understands the necessity that her programs
                        to save your company money through health insurance savings, a decrease in employee
                        absenteeism, and an increase in productivity due to the focus on overall wellness.
                    </h1>
                </div>
            </div>
        </section>
        <section class="hero is-primary">
            <div class="hero-body">
				<div class="container">
					<div class="columns is-vcentered">
						<div class="column">
							<h1 class="title is-1 has-text-dark">
								Like what you see? Your healthy company culture is a click away.
							</h1>
							<h2 class="subtitle is-3 has-text-dark">
								Find out what we can do for you!
							</h2>
							<br />
							<router-link
								to="/contact"
								class="button is-large is-dark is-outlined thick is-rounded"
								style="font-weight: 700"
								>Schedule a Demo</router-link
							>
						</div>
						<div class="column"></div>
					</div>
				</div>
			</div>
        </section>
    </div>
</template>

<script>
import navigation from '@/components/navigation.vue'
import player from '@/components/player.vue'

export default {
    components: {navigation, player},
    data: function(){
        return{
            videoOptions: {
                autoplay: true,
                controls: true,
                sources: [
                    {src: 'https://nyc3.digitaloceanspaces.com/fitcocontent/sample-temple.mp4', type: 'video/mp4'}
                ]
            }
        }
    }
}
</script>